import PromotionListingPage from '../promotion-list';

interface ISubTotalDiscountPromo {}

const SubTotalPromo: React.FunctionComponent<ISubTotalDiscountPromo> = props => {
  return <PromotionListingPage promo={'SUB_TTL_DIS'} promoName="Sub Total Discount" />;
};

export default SubTotalPromo;
